import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../../../common/index.jsx';
import DissertationModal from '../DissertationModal.jsx';
import { useTranslation } from 'react-i18next';
import Form from '../../../../antd/form/Form/Form.jsx';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import FormTextEditor from '../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormDate from '../../../../antd/form/FormDate/FormDate.jsx';
import FormFileUpload from '../../../../antd/form/FormFileUpload/FormFileUpload.jsx';
import dayjs from 'dayjs';

const DissertationForm = ({
  form,
  allStudyPrograms,
  studyPrograms,
  onSubmit,
  initials,
  isCreate,
  summaryFileName,
  fullTextFileName,
  handleProgramChange,
}) => {
  const [insightVisible, showInsight] = useState(false);
  const { t } = useTranslation();
  const { getFieldValue } = form;
  const [selectedStudyPrograms, setSelectedStudyPrograms] = useState(null);
  const studyProgramsOptions = useMemo(() => {
    if (!allStudyPrograms) return [];
    return allStudyPrograms.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }, [allStudyPrograms]);
  const handleStudyProgramsChange = (selectedProgramId) => {
    const selectedProgram = allStudyPrograms.find(
      (value) => value.value === selectedProgramId,
    );
    setSelectedStudyPrograms(selectedProgram ? [selectedProgram] : []);
  };

  const basicInfo = (
    <>
      <CollapseBlock
        collapsible
        collapse
        title={t('Informácie o dizertačnej práci')}
      >
        <FormTextField
          label={t('Autor')}
          name={'student'}
          rules={[required(t)]}
        />

        <FormTextField
          label={t('Názov práce')}
          name={'title'}
          rules={[required(t)]}
        />

        <FormTextField
          label={t('Školiteľ')}
          name={'supervisor'}
          rules={[required(t)]}
        />

        <FormDate
          label={t('Dátum obhajoby')}
          name={'year'}
          rules={[required(t)]}
        />

        <FormSelect
          label={t('Študijný program')}
          name={'study_program_id'}
          rules={[required(t)]}
          options={studyProgramsOptions}
          onChange={handleStudyProgramsChange}
        />

        <FormTextField label={t('Oponent 1')} name={'reviewer1'} />

        <FormTextField label={t('Oponent 2')} name={'reviewer2'} />

        <FormTextField label={t('Oponent 3')} name={'reviewer3'} />
      </CollapseBlock>

      <CollapseBlock collapsible collapse title={t('Abstrakty')}>
        <FormTextEditor
          label={t('Abstrakt (slovensky)')}
          name={'abstract_sk'}
          imgUploadDirectory={'dissertations'}
          fileUploadDirectory={'dissertations'}
        />

        <FormTextEditor
          label={t('Abstrakt (anglicky)')}
          name={'abstract_en'}
          imgUploadDirectory={'dissertations'}
          fileUploadDirectory={'dissertations'}
        />
      </CollapseBlock>
      <CollapseBlock collapsible collapse title={t('Súbory práce')}>
        <FormFileUpload
          label={t('Autoreferát')}
          name={'summary_file'}
          fileName={summaryFileName}
        />

        <FormFileUpload
          label={t('Text práce')}
          name={'fulltext_file'}
          fileName={fullTextFileName}
        />
      </CollapseBlock>
    </>
  );

  return (
    <>
      <Form form={form} onFinish={onSubmit} initialValues={initials}>
        {basicInfo}

        <FormButtonsContainer>
          <FormButton submitOnClick={false} onClick={() => showInsight('SK')}>
            {t('Náhľad')}
          </FormButton>
          <FormButton submitOnClick={true} submitKey={'dissertations'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </Form>

      <DissertationModal
        visible={insightVisible}
        values={form.getFieldsValue(true)}
        togglePostModal={() => showInsight(undefined)}
        studyPrograms={studyPrograms}
        isCreate={isCreate}
      />
    </>
  );
};

DissertationForm.propTypes = {
  formikProps: PropTypes.any,
  allStudyPrograms: PropTypes.array,
  studyPrograms: PropTypes.array,
  onSubmit: PropTypes.func,
  initials: PropTypes.object,
  isCreate: PropTypes.bool,
  summaryFileName: PropTypes.string,
  fullTextFileName: PropTypes.string,
};

export default DissertationForm;
